import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function FAQ() {
    const { t } = useT();
    const [open, setOpen] = useState(0);
    const faqs = [
        { q: t("faq_q1"), a: t("faq_a1") },
        { q: t("faq_q2"), a: t("faq_a2") },
        { q: t("faq_q3"), a: t("faq_a3") },
        { q: t("faq_q4"), a: t("faq_a4") },
        { q: t("faq_q5"), a: t("faq_a5") },
        { q: t("faq_q6"), a: t("faq_a6") },
    ];
    return (
        <section className="max-w-5xl mx-auto px-4 sm:px-6 py-14" data-testid="faq">
            <span className="chip"><HelpCircle className="w-3 h-3" /> {t("faq_chip")}</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
                {t("faq_title")}
            </h2>
            <p className="mt-2 text-slate-400 max-w-2xl">{t("faq_sub")}</p>

            <div className="mt-8 space-y-3">
                {faqs.map((item, i) => (
                    <div
                        key={i}
                        data-testid={`faq-${i}`}
                        className={`card-surface overflow-hidden ${open === i ? "border-emerald-500/40" : ""}`}
                    >
                        <button
                            type="button"
                            onClick={() => setOpen(open === i ? -1 : i)}
                            className="w-full flex items-center justify-between text-left px-5 py-4"
                        >
                            <span className="text-white font-semibold text-sm sm:text-base pr-4">{item.q}</span>
                            <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition ${open === i ? "rotate-180 text-emerald-300" : ""}`} />
                        </button>
                        {open === i && (
                            <div className="px-5 pb-5 text-sm text-slate-300 leading-relaxed border-t border-white/5 pt-3">
                                {item.a}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}
